import { render, staticRenderFns } from "./LanguageIdentifier.vue?vue&type=template&id=5ed08a84&"
import script from "./LanguageIdentifier.vue?vue&type=script&lang=js&"
export * from "./LanguageIdentifier.vue?vue&type=script&lang=js&"
import style0 from "./LanguageIdentifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports